export const BPOINT_1427_TYPES = [
  { id: "CIGO", name: "CIGO/FIS" },
  { id: "CIGO_MALTEMPO", name: "CIGO Maltempo" },
  { id: "FSBA", name: "FSBA" },
];

export const isBpoint1427 = (prestazione) =>
  String(prestazione?.tipologia_fatturazione || "").toUpperCase() === "B" &&
  Number(String(prestazione?.nuovo_codice_ago || prestazione?.codice || "").replace(/^0+/, "")) === 1427;

export const isZucchetti1237 = (prestazione) =>
  String(prestazione?.tipologia_fatturazione || "").toUpperCase() === "Z" &&
  Number(String(prestazione?.nuovo_codice_ago || prestazione?.codice || "").replace(/^0+/, "")) === 1237;

export const isIntegrazioneSalariale = (prestazione) =>
  isBpoint1427(prestazione) || isZucchetti1237(prestazione);

export const calculateBpoint1427 = ({ tipo, dipendenti, settimane, parametri }) => {
  const employees = Number(dipendenti);
  const weeks = Number(settimane);
  if (!tipo || !Number.isInteger(employees) || employees <= 0 || !Number.isInteger(weeks) || weeks <= 0) return null;

  const maximum = Number(parametri?.tetto_massimo);
  let total;
  if (tipo === "FSBA") {
    total = Math.max(Number(parametri?.fsba_minimo), Number(parametri?.fsba_coefficiente) * employees * weeks);
  } else {
    const base = tipo === "CIGO"
      ? Number(parametri?.cigo_quota_base)
      : Number(parametri?.cigo_maltempo_quota_base);
    total = base + Number(parametri?.quota_variabile) * employees * weeks;
  }
  if (!Number.isFinite(total) || !Number.isFinite(maximum)) return null;
  total = Math.ceil((total - 1e-9) / 5) * 5;
  return Math.round(Math.min(maximum, total) * 100) / 100;
};
